<template>
  <!-- ref='select_frame'  ondragstart="return false" -->
  <div >
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>景区管理</el-breadcrumb-item>
  
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <div class="conentDiv">
        <div>
          <el-input v-model="searchData.product" style="width:240px" placeholder="景区名称" clearable />

          <el-select v-model="searchData.province" clearable placeholder="全部省份">
            <el-option
              v-for="item in cityProvince"
              :key="item.provinceCode"
              :label="item.provinceName"
              :value="item.provinceCode"
            ></el-option>
          </el-select>
          <el-select v-model="searchData.status" clearable placeholder="全部状态">
            <el-option
              v-for="item in statusOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>

          <el-button type="primary" @click="searchFn()">查询</el-button>
          <el-button type="primary" @click="searchList">导出</el-button>
          <!-- <el-button  @click="reportInfo">导入信息</el-button> -->
        </div>

        <div>
          <el-upload
            class="upload-demo"
            drag
            :on-success="attachUploadSuccess"
            action="http://xwt.softykt.net/api/jfy/addScenicExcel"
            :data="datas"
            multiple>
              <div>
                导入信息
              </div>
          </el-upload>
          <el-button type="primary" plain @click="editFn()">
            <i class="iconfont icon-jiahao"></i>
            添加景区
          </el-button>
        </div>
      </div>

      <el-table
        :data="scenicData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        :row-class-name="tableRowClassName"
        style="width: 100%"
      >
        <el-table-column prop="ScenicID" label="景区ID"></el-table-column>
        <el-table-column prop="Name" label="景区名称" width="200"></el-table-column>
        <el-table-column prop="user_name" label="超管账号"></el-table-column>
        <el-table-column prop="UserCode" label="App ID"></el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <img
              v-if="scope.row.Status==1"
              src="@/images/worke/dl.png" 
              style=" vertical-align: middle;"
              alt
            />
            <img v-else style=" vertical-align: middle;" src="@/images/worke/dr.png"
             alt />
            <el-button type="text" @click="stateFn(scope.row)">
              <span v-if="scope.row.Status==1">上线</span>
              <span v-else>未上线</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="短信类型">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.charge == 1">计费</span>
              <span v-if="scope.row.charge == 2">计时</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="短信余额" width="200">
          <template slot-scope="scope">
            <span :class="scope.row.Balance<100?'spanRed':''" v-if="scope.row.charge==1">{{scope.row.Balance}}</span>
            <span v-if="scope.row.charge==2">{{scope.row.charge_time}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="300"></el-table-column>
        <el-table-column prop="address" label="操作" width="400">
          <template slot-scope="scope">
            <el-button type="text" @click="roleList(scope.row)">权限授权</el-button>
            <el-button type="text" @click="changeMass(scope.row)">群发短信</el-button>
            <el-button type="text" @click="changePassw(scope.row)">修改密码</el-button>
            <el-button type="text" @click="editFn(scope.row)">详情</el-button>
            <el-button type="text" @click="authorFn(scope.row)">授权</el-button>
            <el-button type="text" @click="recordFn(scope.row)">充值</el-button>
            <el-button type="text" @click="rechargeFn(scope.row)">充值记录</el-button>
            <el-button type="text" @click="clientFn(scope.row)">客户端</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="scenicListPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{scenicListPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="scenicListPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000" ></el-pagination>
      </div>-->
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->
    <!-- 编辑详情开始 -->
    <scenicMangeDialog v-if="editvisible" ref="editOrDatial"></scenicMangeDialog>
    <!-- 编辑详情结束 -->
    <!-- 授权弹框开始 -->
    <scenicAuthorDialog v-if="autorvisible" ref="autorDialog"></scenicAuthorDialog>
    <!-- 授权弹框结束 -->
    <!-- 充值弹框开始 -->
    <scenicRechargeDialog v-if="rechargevisible" ref="rechargeDialog"></scenicRechargeDialog>
    <!-- 充值弹框结束 -->
    <!-- 充值记录弹框开始 -->
    <scenicRecordDialog v-if="recordvisible" ref="recordDialog"></scenicRecordDialog>
    <!-- 充值弹框记录结束 -->
    <!-- 修改密码弹框开始 -->
    <scenicPassWordDialog v-if="passwvisible" ref="passwDialog"></scenicPassWordDialog>
    <!-- 修改密码弹框结束 -->

    <!-- 信息上下线弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="stateDialogVisible"
      :before-close="stateHandleClose"
      width="24%"
      top="30vh"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <div class="autorYj">
        <div>
          <div class="fswc">
            <el-radio-group v-model="statusXx">
              <el-radio :label="1">上线</el-radio>
              <el-radio :label="2">下线</el-radio>
            </el-radio-group>
          </div>
          <div class="autorBtn">
            <el-button class="btnCan" type="text" @click="canclFn">取消</el-button>
            <el-button class="btnSure" type="text" @click="msgFn()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
    <!-- 群发短信 -->
    <el-dialog :close-on-click-modal="false"
      title="群发短信"
      :visible.sync="qfVisible"
      :before-close="qfClose"
      width="24%"
      top="30vh"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <div class="autorYj">
        <div>
          <div class="fswc qf_fswcsss">
            <el-input v-model="qf_input" placeholder="请输入发送多少条短信"></el-input>
            <span>群发短信单价为{{qf_price}}元</span>
          </div>
          <div class="autorBtn">
            <el-button class="btnCan" type="text" @click="qfClose">取消</el-button>
            <el-button class="btnSure" type="text" @click="qfBtns()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="角色权限"
      :visible.sync="rightDialogVisible"
      :before-close="rightHandleClose"
      width="54%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>

      <div class="rightSet">
        <div class="rightWorke">
          <div>
            <span>{{name}}</span>
            <span>该角色用户拥有指定权限</span>
          </div>
          <div class="itemWorke" v-for="(item,index) in limits" :key="index">
            <div v-if="item.son">
              <div>{{item.title}}</div>
              <el-switch v-model="item.c" active-color="#246DEB" inactive-color="#E5E5EA" @change="switchCh(item,$event)"></el-switch>
            </div>
            <div v-if="item.son">
                <el-checkbox  :label="v.id" v-model="v.c" v-for="v in item.son" :key="v.id" @change="CheckBox(item,$event)" >{{v.title}}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="itemRight" style="margin-left:-50px">
        <!-- <el-button @click="clearBtns">清空</el-button> -->
        <el-button class="btnL" @click="Btns">确认添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { scenicPost, statusPost,jfyScenicLogin ,
   ScenicInfoPost , updateQfAccount , scenicPermissionList  , 
   impowerScenicPermission , exportScenicExcel  , addScenicExcel } from "@/request/scenics.js";
import scenicMangeDialog from "./scenicMangeDialog.vue";
import scenicAuthorDialog from "./scenicAuthorDialog.vue";
import scenicRechargeDialog from "./scenicRechargeDialog.vue";
import scenicRecordDialog from "./scenicRecordDialog .vue";
import scenicPassWordDialog from "./scenicPassWordDialog.vue";
import cityOptions from "@/assets/city.json";
import { Message ,MessageBox} from 'element-ui'
export default {
  components: {
    scenicMangeDialog,
    scenicAuthorDialog,
    scenicRechargeDialog,
    scenicRecordDialog,
    scenicPassWordDialog
  },
  data() {
    return {
      rightDialogVisible:false,
      idsrow:'',
      qf_input:'',
      qf_price:0,
      qfVisible:false,
      autorvisible: false, // 授权弹框
      editvisible: false, // 编辑弹框
      stateDialogVisible: false, // 状态弹框
      rechargevisible: false, // 充值弹框
      recordvisible: false, // 充值记录弹框
      passwvisible: false, // 修改密码弹框
      imgXl: require("@/images/scenic/sj.png"),
      imgXlb: require("@/images/scenic/sjh.png"),
      // 列表传参
      scenicListPar: {
        scenic_name: "",
        status: "",
        proid: "",
        page: 1,
        token: ""
      },
      total: 1, // 总条数
      scenicData: [], // 列表数据
      chargeType: "", // 判断短信类型是计时计费,
      // 搜索
      searchData: {
        product: "",
        province: "",
        status: ""
      },
      statusOptions: [
        {
          id: 1,
          label: "上线"
        },
        {
          id: 2,
          label: "未上线"
        }
      ],
      // 信息状态传参
      statusPar: {
        scenic_id: "",
        status: "",
        token: ""
      },
      statusXx: "", // 信息状态绑定的值
      cityProvince: [], // 城市数据
      Token: "",
      scenicId: "",
      limits:'',
      name:'',
      scenic_id:'',
      datas:{
        token: window.sessionStorage.getItem('Token')
      }
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.scenicListPar = {
      scenic_name: "",
      status: "",
      proid: "",
      page: 1,
      token: this.Token
    };
    this.getList(this.scenicListPar);
    this.cityProvince = cityOptions;
    
    this.$refs.select_frame.ondragleave = (e) => {
      e.preventDefault()  // 阻止离开时的浏览器默认行为
    }
    this.$refs.select_frame.ondrop = (e) => {
      e.preventDefault()    // 阻止拖放后的浏览器默认行为
      const data = e.dataTransfer.files[0]  // 获取文件对象
      if (data.length < 1) {
        return  // 检测是否有文件拖拽到页面
      }
      console.log(data)
      this.upload(data)//上传文件的方法
    }
    this.$refs.select_frame.ondragenter = (e) => {
      e.preventDefault()  // 阻止拖入时的浏览器默认行为
      this.$refs.select_frame.border = '2px dashed red'
    }
    this.$refs.select_frame.ondragover = (e) => {
      e.preventDefault()    // 阻止拖来拖去的浏览器默认行为
    }
  },
  methods: {
    upload(data){
      let datas = {
        file:data,
        token:window.sessionStorage.getItem('Token')
      }
      addScenicExcel(datas).then(res=>{
        console.log(res)
      })
    },
    attachUploadSuccess(File){
      if(File.rcode=='200'){
        this.$message.success('添加成功')
        this.scenicListPar.scenic_name = this.searchData.product;
        this.scenicListPar.status = this.searchData.status;
        this.scenicListPar.proid = this.searchData.province;
        this.getList(this.scenicListPar);
      }else{
        this.$message.error(File.msg)
      }
    },
    searchList(){
      let data = {
        status:this.searchData.status,
        Name:this.searchData.product,
        ProID:this.searchData.province
      }
      exportScenicExcel(data).then(res=>{
        if(res.data.status=='ok'){
          window.location.href = res.data.result
        }
      })
    },
    Btns(){
        var auth_id = ''
        this.limits.map(item=>{
          if(item.c==true){
            auth_id += item.id +',' 
          }
          if(item.son!=undefined){
            item.son.map(im=>{
              if(im.c==true){
                auth_id += im.id +',' 
              }
            })
          }
        })
        if (auth_id.length > 0) {
            auth_id = auth_id.substr(0, auth_id.length - 1);
        }
        if(auth_id==''){
          Message.error('请选择权限')
          return false
        }
        let data = {
          token:window.sessionStorage.getItem('Token'),
          scenic_id:this.scenic_id,
          ids:auth_id
        }
        impowerScenicPermission(data).then(res=>{
          if(res.data.status=='ok'){
            this.rightDialogVisible = false;
            this.limits = []
            this.getList( this.scenicListPar);
            Message.success('授权成功')
          }else{
            Message.error(res.data.msg)
          }
      })
    },
    CheckBox(item,e){
      if(e){
        item.c = true
      }else{
        item.c = false
      }
      for(let i=0;i<item.son.length;i++){
          if(item.son[i].c==true){
             item.c = true
            this.$forceUpdate()
             return false
          }
      }
      this.$forceUpdate()
    },
    switchCh(item,e){
      if(e==false){
        if(item.son!=undefined){
          item.son.map(itm=>{
            itm.c = false
          })
        }
      }else{
        item.son.map(itm=>{
          itm.c = true
        })
      }
      this.$forceUpdate()
    },
    roleList(items){
        let data = {
          token:window.sessionStorage.getItem('Token')
        }
        this.name = items.Name
        this.scenic_id = items.ScenicID
        scenicPermissionList(data).then(res=>{
            if(res.status=='200'){
              this.limits = res.data
              if(items.rules!=''){
                items.rules.split(',').map(item=>{
                  this.limits.map(v=>{
                    if(v.id==item){
                      v.c = true
                    }
                    if(v.son!=undefined){
                      v.son.map(itm=>{
                        if(itm.id==item){
                          itm.c = true
                          v.c = true
                        }
                      })
                    }
                  })
                })
              }
              this.rightDialogVisible = true
            }
        })
    },
    rightHandleClose() {
      this.rightDialogVisible = false;
    },
    qfBtns(){
      let data = {
        num:this.qf_input,
        scenic_id:this.idsrow,
        token:window.sessionStorage.getItem('Token')
      }
      updateQfAccount(data).then(res=>{
        if(res.data.rcode=='666'){
          this.qfVisible = false
          Message.success('扣费成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    changeMass(row){
      this.qf_input = ''
      this.idsrow = row.ScenicID
      let data = {
        scenic_id:row.ScenicID,
        token:window.sessionStorage.getItem('Token')
      }
      ScenicInfoPost(data).then(res=>{
        if(res.data.status=='ok'){
          this.qf_price = res.data.result.qf_price
          this.qfVisible = true
        }
      })
    },
    qfClose(){
      this.qfVisible = false
    },
    // 查询
    searchFn() {
      this.scenicListPar.scenic_name = this.searchData.product;
      this.scenicListPar.status = this.searchData.status;
      this.scenicListPar.proid = this.searchData.province;
      this.scenicListPar.page = 1;
      this.getList(this.scenicListPar);
    },
    // 获取列表接口
    getList(data) {
      scenicPost(data).then(res => {
        this.scenicData = res.data.result.data;
        this.total = res.data.result.total;
        this.scenicListPar.page = res.data.result.current_page
      });
    },
    handleCurrentChange(val) {
      this.scenicListPar.page = val;
      this.getList(this.scenicListPar);
    },
    // 点击客户端
    clientFn(row) {
      let flow =  this.rows(row)
      
      if(flow){
        let data = {
          ScenicID:row.ScenicID,
          token:window.sessionStorage.getItem('Token')
        }
        jfyScenicLogin(data).then(res=>{
          if(res.data.status=='ok'){
            const dataId = 'home_data_' + Date.now();
            window.sessionStorage.setItem(dataId, JSON.stringify(res.data.data));
            window.open("/home?dataId=" + encodeURIComponent(dataId), "_blank");
          }
        })
      }else{
          MessageBox('该景区已下线或已欠费, 是否继续进入客户端?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let data = {
              ScenicID:row.ScenicID,
              token:window.sessionStorage.getItem('Token')
            }
            jfyScenicLogin(data).then(res=>{
              if(res.data.status=='ok'){
                window.open("/home?data=" + JSON.stringify(res.data.data), "_blank");
              }
            })
          }).catch(() => {
        });
      }
     
    },
    rows(row){
      if(row.charge==2){
        let time = row.charge_time.split('→')
        const startTime = new Date(time[0]); // 开始时间
        const endTime = new Date(time[1]);
        const currentTime = new Date();
        if (currentTime >= startTime && currentTime <= endTime) {
          return true
        } else {
          return false
        }
      }else{
        if(row.Balance>0){
          return true
        }else{
          return false
        }
      }
    
    },
    // 点击修改密码
    changePassw(row) {
      this.passwvisible = true;
      this.$nextTick(() => {
        this.$refs.passwDialog.passw(row);
      });
    },
    // 点击充值记录
    recordFn(row) {
      this.recordvisible = true;
      this.$nextTick(() => {
        this.$refs.recordDialog.record(row);
      });
    },
    // 点击充值
    rechargeFn(row) {
      this.rechargevisible = true;
      this.$nextTick(() => {
        this.$refs.rechargeDialog.recharge(row);
      });
    },
    // 信息确认按钮
    msgFn() {
      this.statusPar = {
        scenic_id: this.scenicId,
        status: this.statusXx,
        token: this.Token
      };
      // this.statusPar.status = this.statusXx;
      statusPost(this.statusPar).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          this.stateDialogVisible = false;
          let upData = {
            token: this.Token
          };
          this.getList(upData);
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 信息按钮取消
    canclFn() {
      this.stateDialogVisible = false;
    },

    // 点击状态
    stateFn(row) {
      this.scenicId = row.ScenicID;
      this.statusXx = row.Status;
      if (row.Status == 1) {
        this.statusXx = 1;
      } else {
        this.statusXx = 2;
      }
      // if (row.Status == "正常") {
      //   this.statusXx = 1;
      //   console.log(this.statusXx);
      // }
      // if (row.Status == "停用") {
      //   this.statusXx = 2;
      // }
      this.stateDialogVisible = true;
    },
    // 点击状态关闭X
    stateHandleClose() {
      this.stateDialogVisible = false;
    },
    // 点击授权
    authorFn(row) {
      this.autorvisible = true;
      this.$nextTick(() => {
        this.$refs.autorDialog.autor(row);
      });
    },
    // 点击详情编辑
    editFn(row) {
      // console.log(row)
      this.editvisible = true;
      this.$nextTick(() => {
        this.$refs.editOrDatial.detail(row);
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if(row.Status!=1){
        return "warning-row";
      }
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
     
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep  .el-table .warning-row {
  background: rgba(0, 14, 34, 0.5);
}
.activeStatus {
  color: #ff4d4f;
}
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    min-height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.conentBox {
  margin-top: 20px;
  .conentDiv {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      display: flex;
      flex-wrap: wrap;
      .el-input {
        width: 240px;
        margin-right: 20px;
        margin-bottom: 1rem;
      }
      .el-cascader,
      .el-select {
        width: 260px;
        margin-right: 15px;
        margin-bottom: 1rem;
      }
      .el-button {
        width: 100px;
        margin-bottom: 1rem;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        border: none;
      }
    }
    > div:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      .el-button {
        margin-bottom: 1rem;
        width: 120px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #246deb;
      }
    }
  }
}
// .scenicBtn {
//   // width: 596px;
//   height: 40px;
//   display: flex;
//   justify-content: flex-end;
//   margin-left: 42px;
//   .el-button {
//     width: 120px;
//     display: flex;
//     justify-content: center;
//     font-family: ".PingFang SC";
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     // margin-right: -272px;
//     // line-height: 20px;
//     /* identical to box height */

//     color: #246deb;
//     background: #ffffff;
//     border: 1px solid #246deb;
//     border-radius: 4px;
//   }
// }

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.spanRed{
  color: red;
}

/deep/ .el-input__inner{
  color: #666666;
}
/deep/ .el-dialog__title{
   color: #000 !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
/deep/.el-dialog__headerbtn{
  top: 0;
}
.qf_fswcsss{
  display: flex;
  flex-direction: column;
  >span{
    margin-top: 2rem;
    color: red;
    font-size: 1.6rem;
  }
}
.rightSet {
  .rightWorke {
    > div:nth-child(1) {
      margin-bottom: 7px;
      > span:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        text-align: center;
        color: #000000;
        margin-right: 10px;
      }
    }
    .itemWorke {
      margin-bottom: 17px;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #666666;
        margin-bottom: 5px;
      }
      > div:nth-child(2) {
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        padding: 20px;
        // height: 44px;
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #4ecb73;
          border-color: #4ecb73;
        }
        /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #666666;
        }
      }
    }
  }
}
.itemRight {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 30px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
::v-deep .el-upload-list{
  display: none;
}
::v-deep .el-upload-dragger{
  margin-right: 1rem;
  width: 10rem;
  height: 4.3rem;
  margin-left: 1rem;
  color: #fff;
  background: #246deb;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
}
</style>